import React from "react";
import { motion, AnimatePresence } from "framer-motion";

const Loader = ({ show }) => {
  return (
    <AnimatePresence>
      {show && (
        <motion.div
          key="loader"
          initial={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          className="fixed inset-0 z-[100] flex items-center justify-center bg-[#030305]"
          data-testid="page-loader"
        >
          <div className="relative flex flex-col items-center gap-6">
            <div className="relative w-20 h-20">
              <motion.span
                className="absolute inset-0 rounded-full border border-cyan-400/40"
                animate={{ scale: [1, 1.6, 1], opacity: [0.8, 0, 0.8] }}
                transition={{ duration: 1.8, repeat: Infinity, ease: "easeInOut" }}
              />
              <motion.span
                className="absolute inset-2 rounded-full border border-violet-400/40"
                animate={{ scale: [1, 1.4, 1], opacity: [0.7, 0, 0.7] }}
                transition={{ duration: 1.8, repeat: Infinity, ease: "easeInOut", delay: 0.4 }}
              />
              <motion.div
                className="absolute inset-5 rounded-full bg-gradient-to-br from-cyan-400 to-violet-500"
                animate={{ rotate: 360 }}
                transition={{ duration: 4, repeat: Infinity, ease: "linear" }}
              />
            </div>
            <div className="font-mono text-[11px] tracking-[0.4em] text-cyan-300/80 uppercase">
              Initializing
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default Loader;
